import { combineReducers } from 'redux';
import { commonState } from './common';
import { cartState } from './cart';
import { couponState } from './coupon';
// import { headerState } from './header';
// import { footerState } from './footer';
import { memberState } from './member';
import { johnsState } from './johnsProduct';
import { indexState } from './pageIndex';
import { orderListState } from './orderList';
import { shoppingInfoState } from './shoppingInfo';
import { productState } from './product';
import { orderDetailState } from './orderDetail';
import { mmmState } from './mmmIndex';

export default combineReducers({
  commonState,
  // headerState,
  // footerState,
  mmmState,
  johnsState,
  memberState,
  indexState,
  orderListState,
  shoppingInfoState,
  cartState,
  productState,
  orderDetailState,
  couponState,
});
